<div class="ac"
     [class.is-link]="!isLoading && cardData?.link"
     [attr.role]="!isLoading && cardData?.link ? 'link' : null"
     [attr.tabindex]="!isLoading && cardData?.link ? 0 : null"
     (click)="!isLoading && cardData?.link && navigateToRoute(cardData.link.route)"
     (keydown.enter)="!isLoading && cardData?.link && navigateToRoute(cardData.link.route)">

  <div class="ac-skel" *ngIf="isLoading">
    <ion-skeleton-text [animated]="true" class="sk-label"></ion-skeleton-text>
    <ion-skeleton-text [animated]="true" class="sk-num"></ion-skeleton-text>
    <ion-skeleton-text [animated]="true" class="sk-line"></ion-skeleton-text>
  </div>

  <ng-container *ngIf="!isLoading && cardData">
    <div class="ac-label">{{ cardData.label }}</div>

    <div class="ac-num" *ngIf="cardData.number !== null; else dash">
      {{ cardData.number }}{{ cardData.suffix || '' }}<small *ngIf="cardData.unit">{{ cardData.unit }}</small>
    </div>
    <ng-template #dash><div class="ac-num dim">&mdash;</div></ng-template>

    <div class="ac-bar" *ngIf="cardData.bar">
      <i class="filled" [style.width.%]="cardData.bar.pct"></i>
      <i class="unfilled" [style.width.%]="100 - cardData.bar.pct"></i>
    </div>

    <div class="ac-row" *ngFor="let row of cardData.rows" [innerHTML]="row"></div>
    <div class="ac-row empty" *ngIf="cardData.empty">{{ cardData.empty }}</div>

    <span *ngIf="cardData.link" class="ac-link">{{ cardData.link.text }} &rsaquo;</span>
  </ng-container>
</div>
